var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center"},[_c('v-progress-circular',{staticClass:"ma-15",attrs:{"indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }